import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import BootstrapData from 'utils/BootstrapData';
import ClientSideMetrics from 'utils/ClientSideMetrics';
import ClientSideErrorActionCreator from 'actions/errors/ClientSideErrorActionCreator';

const SORRY_STRING_ID = 'AA_Sorry';
const ERROR_STRING_ID = 'AA_Error';
class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    fatalAjaxResponseOccurred: PropTypes.bool,
  };

  state = { error: null };

  constructor() {
    super();
    const dataEl = document.getElementById('__data__');
    const data = dataEl ? JSON.parse(dataEl.innerHTML) : {};
    const bootstrapData = new BootstrapData(data);
    const { strings } = bootstrapData.getState().i18n;
    this.STRINGS = {
      ERROR: strings[ERROR_STRING_ID],
      SORRY: strings[SORRY_STRING_ID],
    };
  }

  componentDidCatch(error) {
    this.setState({ error });
  }

  render() {
    const {
      children,
      fatalAjaxResponseOccurred,
    } = this.props;
    const { error } = this.state;
    if (error || fatalAjaxResponseOccurred) {
      // Sometimes error is a number
      ClientSideErrorActionCreator.log(error ? error.message : 'Fatal Ajax Detected', error, window.location);
      ClientSideMetrics.error(error, window.location.pathname);
      return (
        <Container textAlign="center">
          <h2>{this.STRINGS.SORRY}</h2>
          {/* eslint-disable-next-line react/no-danger */}
          <h3 dangerouslySetInnerHTML={{ __html: this.STRINGS.ERROR }} />
        </Container>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
